/** The shape the page hands the client. Mirrors scripts/templates/tryit.ts. */

export type TryItRisk = 'safe' | 'mutating' | 'destructive';

export interface TryItParam {
  name: string;
  in: 'path' | 'query' | 'header';
  required: boolean;
  description?: string;
  example?: string;
  enum?: string[];
  type?: string;
}

export interface TryItSpec {
  operationId: string;
  summary: string;
  method: string;
  server: string;
  path: string;
  requiresAuth: boolean;
  risk: TryItRisk;
  params: TryItParam[];
  body?: { contentType: string; example: string };
  auth: {
    authApiBase: string;
    loginUrl: string;
    tokenKey: string;
    aliasKey: string;
  };
}

export function readSpec(root: HTMLElement): TryItSpec | null {
  const node = root.querySelector<HTMLScriptElement>('.tryit-spec');
  if (!node?.textContent) return null;
  try {
    return JSON.parse(node.textContent) as TryItSpec;
  } catch {
    return null;
  }
}
